import moment from 'moment';
import { CsvBuilder } from 'filefy';

import { generateData } from './generate-data';

export function handleExportCsv(
  columns,
  renderData,
  exportData,
  columnsForExport,
  title
) {
  if (exportData && columnsForExport) {
    const columnTitles = columnsForExport.map((columnDef) => columnDef.title);

    const csvData = generateData(exportData, columnsForExport);

    const epoch = Date.now();

    return new CsvBuilder(
      `${title}_${moment(new Date(epoch)).format('DD-MM-YYYY_HH.mm')}.csv`
    )
      .setDelimeter(',')
      .setColumns(columnTitles)
      .addRows(csvData)
      .exportFile();
  }
  const columnTitles = columns.map((columnDef) => columnDef.title);

  const csvData = generateData(renderData, columns);

  const epoch = Date.now();

  return new CsvBuilder(
    `${title}_${moment(new Date(epoch)).format('DD-MM-YYYY_HH.mm')}.csv`
  )
    .setDelimeter(',')
    .setColumns(columnTitles)
    .addRows(csvData)
    .exportFile();
}
